// Well-known numeric facts for Higher or Lower. Every value is distinct so a round always has a clear winner.
export const NUMBER_FACTS = [
  { q: 'Height of Mount Everest (metres)', v: 8849 },
  { q: 'Length of the River Nile (km)', v: 6650 },
  { q: 'Number of states in Nigeria', v: 36 },
  { q: 'Year Nigeria became independent', v: 1960 },
  { q: 'Bones in an adult human body', v: 206 },
  { q: 'Players on the pitch for one football team', v: 11 },
  { q: 'Rings in the Olympic symbol', v: 5 },
  { q: 'Continents on Earth', v: 7 },
  { q: 'Days in a leap year', v: 366 },
  { q: 'Planets in our solar system', v: 8 },
  { q: 'Letters in the English alphabet', v: 26 },
  { q: 'Keys on a standard piano', v: 88 },
  { q: 'Local government areas in Nigeria', v: 774 },
  { q: 'Colours in a rainbow', v: 7 },
  { q: 'Height of the Burj Khalifa (metres)', v: 828 },
  { q: 'Year of the first modern Olympic Games', v: 1896 },
  { q: 'Teeth in a full adult mouth', v: 32 },
  { q: 'Hours in one week', v: 168 },
  { q: 'Freezing point of water (°F)', v: 32 },
  { q: 'Boiling point of water (°C)', v: 100 },
  { q: 'Height of Chappal Waddi, Nigeria\'s highest point (metres)', v: 2419 },
  { q: 'Year Nigeria returned to civilian rule', v: 1999 },
  { q: 'Minutes in a full football match (without extra time)', v: 90 },
  { q: 'Sides on a hexagon', v: 6 },
  { q: 'Months in a year', v: 12 },
  { q: 'Degrees in a right angle', v: 90 },
  { q: 'Degrees in a full circle', v: 360 },
  { q: 'Zones in Nigeria\'s geopolitical split', v: 6 },
  { q: 'Countries in Africa (approx.)', v: 54 },
  { q: 'Days in February in a normal year', v: 28 },
];

export const NUMBER_FACTS_EXTRA = [
  { q: 'Height of Mount Kilimanjaro (metres)', v: 5895 },
  { q: 'Length of the River Niger (km)', v: 4180 },
  { q: 'Length of the Amazon River (km, approx.)', v: 6400 },
  { q: 'Speed of light (km per second, approx.)', v: 299792 },
  { q: 'Distance from Earth to the Moon (km, approx.)', v: 384400 },
  { q: 'Distance from Earth to the Sun (million km, approx.)', v: 150 },
  { q: 'Diameter of the Earth (km, approx.)', v: 12742 },
  { q: 'Speed of sound in air (metres per second, approx.)', v: 343 },
  { q: 'Absolute zero (°C)', v: -273 },
  { q: 'Normal human body temperature (°C)', v: 37 },
  { q: 'Chemical elements on the periodic table', v: 118 },
  { q: 'Chromosomes in a human body cell', v: 46 },
  { q: 'Atomic number of gold', v: 79 },
  { q: 'Atomic number of carbon', v: 6 },
  { q: 'Degrees in a full circle', v: 360 },
  { q: 'Degrees in the angles of a triangle', v: 180 },
  { q: 'Two to the power of ten', v: 1024 },
  { q: 'Days in a normal year', v: 365 },
  { q: 'Minutes in a day', v: 1440 },
  { q: 'Seconds in an hour', v: 3600 },
  { q: 'Seconds in a day', v: 86400 },
  { q: 'Weeks in a year', v: 52 },
  { q: 'Minutes in an hour', v: 60 },
  { q: 'Hours in a day', v: 24 },
  { q: 'Year of the Amalgamation of Nigeria', v: 1914 },
  { q: 'Year Nigeria became a republic', v: 1963 },
  { q: 'Year Abuja became Nigeria\'s capital', v: 1991 },
  { q: 'Year of the first military coup in Nigeria', v: 1966 },
  { q: 'Year of the Berlin Conference on Africa', v: 1884 },
  { q: 'Year Britain abolished the slave trade', v: 1807 },
  { q: 'Year Ghana became independent', v: 1957 },
  { q: 'Year Nelson Mandela was released from prison', v: 1990 },
  { q: 'Year humans first landed on the Moon', v: 1969 },
  { q: 'Year World War II ended', v: 1945 },
  { q: 'Year World War I ended', v: 1918 },
  { q: 'Year Nigeria won Olympic football gold', v: 1996 },
  { q: 'Year Nigeria first won the Africa Cup of Nations', v: 1980 },
  { q: 'Year Wole Soyinka won the Nobel Prize', v: 1986 },
  { q: 'Year Things Fall Apart was published', v: 1958 },
  { q: 'Year the Titanic sank', v: 1912 },
  { q: 'Year Columbus reached the Americas', v: 1492 },
  { q: 'Year of the French Revolution', v: 1789 },
  { q: 'Year the World Wide Web was invented', v: 1989 },
  { q: 'Year the first iPhone launched', v: 2007 },
  { q: 'Year Google was founded', v: 1998 },
  { q: 'Year Facebook launched', v: 2004 },
  { q: 'Year GSM mobile phones launched in Nigeria', v: 2001 },
  { q: 'Year of the American Declaration of Independence', v: 1776 },
  { q: 'Senators in Nigeria\'s Senate', v: 109 },
  { q: 'Members of Nigeria\'s House of Representatives', v: 360 },
  { q: 'Area of Nigeria (square km, approx.)', v: 923768 },
  { q: 'States in Nigeria plus the FCT', v: 37 },
  { q: 'Countries recognised by the United Nations', v: 193 },
  { q: 'Area of Africa (million square km, approx.)', v: 30 },
  { q: 'Letters in the Greek alphabet', v: 24 },
  { q: 'Stars on the flag of the USA', v: 50 },
  { q: 'Strings on a standard guitar', v: 6 },
  { q: 'Holes in a full round of golf', v: 18 },
  { q: 'Squares on a chess board', v: 64 },
  { q: 'Distance of a marathon (km)', v: 42.195 },
  { q: 'Grand Slam tennis tournaments each year', v: 4 },
  { q: 'Bones in the human hand and wrist', v: 27 },
  { q: 'Muscles in the human body (approx.)', v: 600 },
  { q: 'Players in a rugby union team on the field', v: 15 },
  { q: 'Players in a cricket team on the field', v: 11 },
  { q: 'Number of Nobel Prize categories', v: 6 },
  { q: 'Time zones used in Russia', v: 11 },
  { q: 'Sides on a dodecagon', v: 12 },
  { q: 'Average adult human heartbeats per minute (resting, approx.)', v: 72 },
  { q: 'Litres of blood in an adult body (approx.)', v: 5 },
  { q: 'Age at which Nigerians can vote', v: 18 },
  { q: 'Population of the world in billions (approx.)', v: 8 },
  { q: 'Length of the Great Wall of China (km, approx.)', v: 21196 },
  { q: 'Height of the Eiffel Tower (metres)', v: 330 },
  { q: 'Height of the Statue of Liberty with its base (metres)', v: 93 },
  { q: 'Speed record of the fastest land animal, the cheetah (km/h, approx.)', v: 100 },
  { q: 'Number of Great Lakes in North America', v: 5 },
  { q: 'Height of Zuma Rock above ground (metres, approx.)', v: 725 },
  { q: 'Length of Nigeria\'s coastline (km, approx.)', v: 853 },
  { q: 'Length of the Lagos Third Mainland Bridge (km, approx.)', v: 11.8 },
  { q: 'Number of official languages of the United Nations', v: 6 },
];

// De-duplicated: if two facts share a value, keep the first.
export const NUMBER_FACTS_ALL = (() => {
  const seen = new Set();
  return [...NUMBER_FACTS, ...NUMBER_FACTS_EXTRA].filter((f) => (seen.has(f.v) ? false : (seen.add(f.v), true)));
})();
